export default __webpack_public_path__ + "static/media/0xa731349fa468614c1698fc46ebf06da6f380239e.cf5fa103.webp";